import React from "react";
import { usePublicStyles } from "./basicPublicLayout.styles";

interface BasicPublicLayoutProps {
    children: React.ReactNode;
}

const BasicPublicLayout: React.FC<BasicPublicLayoutProps> = ({ children }: BasicPublicLayoutProps): JSX.Element => {
    const publicClasses = usePublicStyles();
    return <div className={publicClasses.root}>{children}</div>;
};

export default BasicPublicLayout;
